<template>
    <div class="leadingCockitMap">
        <van-nav-bar
            title="经营驾驶舱"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="filterConditions">
            <div class="time iconfont iconriqi" @click="startPickerShow = true;">
                <input type="text" v-model="startTime" readonly>
            </div>
            <div class="line"></div>
            <div class="time iconfont iconriqi" @click="endPickerShow = true;">
                <input type="text" v-model="endTime" readonly>
            </div>
        </div>
        <van-popup v-model="startPickerShow" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="startTimeValue"
                type="year-month"
                title="选择年月"
                @confirm="startPickerConfirmData"
                @cancel="startPickerShow = false"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="endPickerShow" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="endTimeValue"
                type="year-month"
                title="选择年月"
                @confirm="endPickerConfirmData"
                @cancel="endPickerShow = false"
            ></van-datetime-picker>
        </van-popup>
        <div class="data-panel">
            <div class="data-item" @click="to('yearAmount')">
                <img class="icon" src="../../../assets/images/leadingCockpit/liang_home.png">
                <div class="data-box">
                    <div class="data-name">
                        年累计销量>>
                    </div>
                    <div class="data-num n1">
                        {{ statisData.quantity }}<span>万方</span>
                    </div>
                </div>
            </div>
            <div class="data-item" @click="to('yearPrice')">
                <img class="icon" src="../../../assets/images/leadingCockpit/jia_home.png">
                <div class="data-box">
                    <div class="data-name">
                        年度均价>>
                    </div>
                    <div class="data-num n2">
                        {{ statisData.price }}<span>元/方</span>
                    </div>
                </div>
            </div>
            <div class="data-item" @click="to('yearCost')">
                <img class="icon" src="../../../assets/images/leadingCockpit/ben_home.png">
                <div class="data-box">
                    <div class="data-name">
                        年平均单方成本>>
                    </div>
                    <div class="data-num n4">
                        {{ statisData.single_volume_cost }}<span>元/方</span>
                    </div>
                </div>
            </div>
            <div class="data-item" @click="to('yearProfit')">
                <img class="icon" src="../../../assets/images/leadingCockpit/li_home.png">
                <div class="data-box">
                    <div class="data-name">
                        本年度毛利额>>
                    </div>
                    <div class="data-num n5">
                        {{ statisData.gross_profit }}<span>元/方</span>
                    </div>
                </div>
            </div>
            <div class="data-item" @click="to('yearKuan')">
                <img class="icon" src="../../../assets/images/leadingCockpit/kuan_home.png">
                <div class="data-box">
                    <div class="data-name">
                        应收款余额>>
                    </div>
                    <div class="data-num n3">
                        {{ statisData.balance }}<span>万元</span>
                    </div>
                </div>
            </div>
        </div>
        <!--        图例-->
        <div class="legend-data">
            <h2 class="title">
                图例
            </h2>
            <p>
                <img src="../../../assets/images/leadingCockpit/location_home_normal.png">
                <span>第1批试点企业({{ batchData.batch1Count }})</span>
            </p>
            <p>
                <img src="../../../assets/images/leadingCockpit/location_2_normal.png">
                <span>第2批试点企业({{ batchData.batch2Count }})</span>
            </p>
        </div>
        <div class="city-data" v-show="curOrgId">
            <h2 class="title">
                {{ selectedBusinessData.tenant_name }}
            </h2>
            <div class="data-item">
                <div class="data-name">
                    当月销量(万方)
                </div>
                <div class="data-num n1">
                    {{ selectedBusinessData.quantity }}
                </div>
            </div>
            <div class="data-item">
                <div class="data-name">
                    当月营业收入(万元)
                </div>
                <div class="data-num n2">
                    {{ selectedBusinessData.receivables }}
                </div>
            </div>
            <div class="data-item">
                <div class="data-name">
                    应收账款余额(万元)
                </div>
                <div class="data-num n3">
                    {{ selectedBusinessData.balance }}
                </div>
            </div>
            <div class="data-item">
                <div class="data-name">
                    当月售价(元/方)
                </div>
                <div class="data-num n4">
                    {{ selectedBusinessData.price }}
                </div>
            </div>
            <div class="data-item">
                <div class="data-name">
                    单方成本(元/方)
                </div>
                <div class="data-num n5">
                    {{ selectedBusinessData.single_volume_cost }}
                </div>
            </div>
            <div class="data-item">
                <div class="data-name">
                    毛利额(元/方)
                </div>
                <div class="data-num n6">
                    {{ selectedBusinessData.gross_profit }}
                </div>
            </div>
        </div>
        <div class="map-contain">
            <div id="mapChart"></div>
        </div>
    </div>
</template>
<script>
import batch2flagImg from '../../../assets/images/leadingCockpit/location_2_normal.png';
import batch2LightImg from '../../../assets/images/leadingCockpit/location_2_highlight.png';
export default {
    name: 'leading-cockit-map',
    data() {
        return {
            startTime: '',
            endTime: '',
            startTimeValue: '',
            endTimeValue: '',
            startPickerShow: false,
            endPickerShow: false,
            statisData: {}, // 统计数据
            businessData: {}, // 企业数据
            selectedBusinessData: {
                tenant_name: '', // 企业名称
                quantity: 0, //
                receivables: 0,
                balance: 0,
                price: 0,
                single_volume_cost: 0,
                gross_profit: 0,
            }, // 当前选中的企业数据
            batchData: {},
            curOrgId: '', // 选中的企业数据
        };
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'leading-cockit-map');
        }
        next();
    },
    created() {
        const curDate = new Date();
        this.startTimeValue = new Date(curDate.getFullYear(), 0);
        this.endTimeValue = new Date();
        this.startTime = this.formatDate(this.startTimeValue);
        this.endTime = this.formatDate(this.endTimeValue);
        this.initData();
    },
    mounted() {
        this.drawMap('mapChart');
    },
    methods: {
        // 初始化数据
        async initData() {
            const statisData = await this.getYearAmountData();
            Object.keys(statisData).forEach(key => {
                statisData[key] = statisData[key].toFixed(2);
            });
            this.statisData = statisData;
            this.setSelectedBusinessData();
        },
        // 设置当前选中的企业数据
        async setSelectedBusinessData( name) {
            if (this.curOrgId) {
                const telentData = await this.getTelentAmountData();
                if (name) {
                    this.selectedBusinessData.tenant_name = name;
                }
                this.selectedBusinessData.quantity = telentData.quantity.toFixed(2);
                this.selectedBusinessData.receivables = telentData.receivables.toFixed(2);
                this.selectedBusinessData.balance = telentData.balance.toFixed(2);
                this.selectedBusinessData.price = telentData.price.toFixed(2);
                this.selectedBusinessData.single_volume_cost = telentData.single_volume_cost.toFixed(2);
                this.selectedBusinessData.gross_profit = telentData.gross_profit.toFixed(2);
            }
        },
        // 地图
        async drawMap(value) {
            // 动态设置 标点 获取组织机构 公司
            const orgList = await this.getEnterpriceList();

            const batch1 = []; const batch2 = [];
            orgList.forEach(item => {
                // eslint-disable-next-line eqeqeq
                if (item.launch_batch == '1') {
                    batch1.push(item);
                    // eslint-disable-next-line eqeqeq
                } if (item.launch_batch == '2') {
                    batch2.push(item);
                }
            });
            const geoCoordMap1 = {}; const data1 = [];
            const shortName = name => {
                return name.replace(/商混|砼享云/, '');
            };
            batch1.forEach(item => {
                geoCoordMap1[item.org_shortname] = [item.x_coordinate_point, item.y_coordinate_point];
                data1.push({
                    orgId: item.id,
                    name: item.org_shortname,
                    transAmt: shortName(item.org_shortname || item.org_name),
                    serviceRate: 99,
                });
            });
            // 第二批次
            const geoCoordMap2 = {}; const data2 = [];
            batch2.forEach(item => {
                geoCoordMap2[item.org_shortname] = [item.x_coordinate_point, item.y_coordinate_point];
                data2.push({
                    orgId: item.id,
                    name: item.org_shortname,
                    transAmt: shortName(item.org_shortname),
                    serviceRate: 99,
                });
            });
            this.batchData.batch1Count = batch1.length;
            this.batchData.batch2Count = batch2.length;
            this.$axios.get('./../../mapJson/china.json').then(geoJson => {
                this.$echarts.registerMap('china', geoJson);
                const drawMapChart = this.$echarts.init(document.getElementById(value));
                const convertData = function (data, geoCoordMap) {
                    const res = [];
                    for (let i = 0; i < data.length; i++) {
                        const geoCoord = geoCoordMap[data[i].name];
                        if (geoCoord) {
                            res.push({
                                orgId: data[i].orgId,
                                name: data[i].name,
                                value: geoCoord.concat(data[i].transAmt),
                            });
                        }
                    }
                    return res;
                };
                const mapOption = {
                    // 鼠标提示框
                    tooltip: {
                        trigger: 'item',
                        showDelay: 0,
                        backgroundColor: 'rgba(0,0,0,0)',
                        transitionDuration: 0.2,
                        axisPointer: {
                            type: 'line',
                            lineStyle: {
                                color: '#ffa147',
                                width: 2,
                                type: 'dashed',
                            },
                        },
                        // eslint-disable-next-line consistent-return
                        formatter: params => {
                            if (params.seriesType === 'scatter') {
                                if (this.curOrgId !== params.data.orgId) {
                                    this.curOrgId = params.data.orgId;
                                    this.setSelectedBusinessData(params.name);
                                }
                            } else {
                                this.curOrgId = '';
                            }
                        },
                    },
                    visualMap: {
                        show: false,
                        left: 'right',
                        min: 100,
                        max: 3800,
                        inRange: {
                            color: ['#016ABB', '#014FB1', '#2536AA', '#0055B0'],
                        },
                        text: ['High', 'Low'], // 文本，默认为数值文本
                        calculable: true,
                        seriesIndex: [0],
                    },
                    geo: {
                        name: '1',
                        type: 'map',
                        map: 'china', // 类型,与上文中注册地图的名称一致
                        zoom: 3, // 当前视角的缩放比例
                        roam: true, // 是否开启平游或缩放
                        label: {
                            normal: {
                                show: true,
                                color: '#04B3F4', // 每个区域文字颜色
                                fontSize: '16px',
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                        mapLocation: {
                            y: 60,
                        },
                        itemStyle: {
                            emphasis: {
                                label: {
                                    show: false,
                                },
                            },
                            normal: {
                                label: {
                                    show: !0,
                                },
                                formatter: function formatter(a) {
                                    return a.value;
                                },
                                borderColor: '#063E71', // 每个区域的边框色
                                areaColor: '#0d1c31', // 区域背景色
                            },

                        },
                        center: [116.9972, 36.6683],
                    },
                    series: [{
                        type: 'map',
                        map: 'china',
                        geoIndex: 0,
                        aspectScale: 0.75, // 长宽比
                        showLegendSymbol: false, // 存在legend时显示
                        label: {
                            normal: {
                                show: true,
                                color: '#04B3F4', // 每个区域文字颜色
                                fontSize: '16px',
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                        mapLocation: {
                            y: 60,
                        },
                        itemStyle: {
                            emphasis: {
                                label: {
                                    show: false,
                                },
                            },
                            normal: {
                                label: {
                                    show: !0,
                                },
                                formatter: function formatter(a) {
                                    return a.value;
                                },
                                borderColor: '#063E71', // 每个区域的边框色
                                areaColor: '#0d1c31', // 区域背景色
                            },

                        },
                        animation: false,
                        data: [
                            {
                                name: '北京',
                                value: 125,
                            },
                            {
                                name: '河北',
                                value: 125,
                            },
                            {
                                name: '山东',
                                value: 125,
                            },
                            {
                                name: '河南',
                                value: 125,
                            },
                            {
                                name: '安徽',
                                value: 125,
                            },
                            {
                                name: '江苏',
                                value: 125,
                            },
                        ],
                    }, {

                        symbolSize: 5,
                        label: {
                            normal: {
                                formatter: '{b}',
                                position: 'right',
                                show: false,
                            },
                            emphasis: {
                                show: true,
                            },
                        },
                        itemStyle: {
                            normal: {
                                color: '#fff',
                            },
                        },
                        name: 'light',
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: convertData(data1, geoCoordMap1),

                    }, {
                        name: 'Top 5',
                        type: 'scatter', // 地图上的气泡标记
                        coordinateSystem: 'geo',
                        symbol: 'pin',
                        symbolSize: [50, 50],
                        label: {
                            normal: {
                                show: true,
                                textStyle: {
                                    color: '#fff',
                                    fontSize: 12,
                                    fontFamily: 'technology',
                                },
                                formatter(value) {
                                    return value.data.value[2];
                                },
                            },
                        },
                        itemStyle: {
                            normal: {
                                color: '#5EC875',
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                color: '#B37AE7',
                                opacity: 1,
                            },
                            label: {
                                color: '#FFFFFF',
                                opacity: 1,
                            },
                        },
                        data: convertData(data1, geoCoordMap1),
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke',
                        },
                        hoverAnimation: true,
                        zlevel: 1,
                    },
                    {
                        name: 'Top 6',
                        type: 'scatter', // 地图上的气泡标记
                        coordinateSystem: 'geo',
                        symbol: 'image://' + batch2flagImg,
                        symbolSize: [35, 34],
                        label: {
                            normal: {
                                show: true,
                                textStyle: {
                                    color: '#fff',
                                    fontSize: 12,
                                    fontFamily: 'technology',
                                },
                                formatter(value) {
                                    return value.data.value[2];
                                },
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                color: {
                                    image: batch2LightImg,
                                    repeat: 'no-repeat',
                                },
                                opacity: 1,
                            },
                            label: {
                                color: '#FFFFFF',
                                opacity: 1,
                            },
                        },
                        data: convertData(data2, geoCoordMap2),
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke',
                        },
                        hoverAnimation: true,
                        zlevel: 1,
                    },
                    ],
                };
                drawMapChart.setOption(mapOption);
                drawMapChart.resize();
            });
            this.$forceUpdate();
        },


        // 通过类型获取指定组织下所有指定类型的组织、
        getOrgList(org_id, org_type) {
            const url = `/interfaceApi/basicplatform/orgtree/orgtype/${org_id}/${org_type}?page=1&row=9999`;
            return this.$axios.get(url);
        },
        // 获取年度数据
        getYearAmountData() {
            return this.$axios.get(`/interfaceApi/report/leadercockpit/year_statistics_data?startDate=${this.startTime}&endDate=${this.endTime}`);
        },
        // 获取企业统计数据
        getTelentAmountData() {
            return this.$axios.get(`/interfaceApi/report/leadercockpit/month_statistics_data/${this.curOrgId}?date=${this.endTime}`);
        },
        // 获取上线企业列表
        async getEnterpriceList(org_id = '') {
            const path = '/interfaceApi/report/leadercockpit/getorgdata?org_id=' + org_id;
            const data = await this.$axios.$get(path) || [];
            return data;
        },
        // 确认选择时间
        startPickerConfirmData(val) {
            if (this.validDate(val, this.endTimeValue)) {
                this.startTime = this.formatDate(val);
                this.initData();
                this.startPickerShow = false;
            }
        },
        // 确认选择时间
        endPickerConfirmData(val) {
            if (this.validDate(this.startTimeValue, val)) {
                this.endTime = this.formatDate(val);
                this.initData();
                this.endPickerShow = false;
            }
        },
        // 验证时间
        // 验证时间
        validDate(startDate, endDate) {
            const startDateStr = this.formatDate(startDate);
            const endDateStr = this.formatDate(endDate);
            if (startDateStr > endDateStr) {
                this.$toast('开始时间不能大于结束时间！');
                return false;
            }
            if (startDate.getFullYear() !== endDate.getFullYear()) {
                this.$toast('不能跨年选择时间！');
                return false;
            }
            return true;
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转页面
        to(path) {
            this.$router.isBack = 2;
            this.$router.push({ name: path, params: {
                startDate: this.startTime,
                endDate: this.endTime,
            } });
        },
    },
};
</script>
<style scoped  lang="stylus">
    @font-face
        font-family technology
        src url('../../../assets/fonts/font/technology.ttf')
    .leadingCockitMap
        .filterConditions
            display flex
            height 40rpx
            padding 15rpx 10rpx
            background: rgba(2, 23, 50, 0.98);
            box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.5);
            justify-content center
            align-items center
            .line
                width: 20rpx;
                height: 2px;
                background: rgba(255, 255, 255, 0.2);
            .time
                width 80rpx
                height 30rpx
                line-height 28rpx
                margin 0 5rpx
                position relative
                input
                    width 130rpx
                    height 30rpx
                    border none
                    text-indent 30rpx
                    background: transparent;
                    font-size 14rpx;
                    color:#fff;
                    font-family: Technology-Regular, Technology;
                &:before
                    line-height 30rpx
                    font-size 16rpx
                    color #0096F8
                    position absolute
                    left 5rpx
        .data-panel
            position absolute
            left 0
            right 0
            margin-top 15rpx
            margin 0 auto
            width 96%
            z-index: 99;
            background url("../../../assets/images/leadingCockpit/bg_home_1.png") no-repeat center
            background-size 100% 100%
            display flex
            flex-wrap wrap
            padding  20rpx 10rpx
            .data-item
                display flex
                align-items center
                padding-left 20rpx;
                width 50%;
                height 60rpx;
                .icon
                    width 42rpx;
                    height 42rpx;
                    margin-right 12rpx;
                .data-box
                    .data-name
                        font-size: 10rpx;
                        margin-bottom 1rpx
                        color #fff
                        opacity 0.6
                        font-family: Helvetica Neue, Helvetica, Segoe UI, Roboto, Arial, sans-serif;
                    .data-num
                        font-size 16rpx;
                        font-family: Technology-Regular, Technology;
                        font-weight bold
                        span
                            font-size 14rpx;
                    .n1
                        color #44D7B6
                    .n2
                        color #FA6400
                    .n3
                        color #11A4D5
                    .n4
                        color #F7B500
                    .n5
                        color #6DD400
    .city-data
        position fixed
        left 0
        right 0
        bottom 10rpx
        margin 0 auto
        width 96%
        z-index: 99;
        background url("../../../assets/images/leadingCockpit/bg_home_2.png") no-repeat center
        background-size 100% 100%
        display flex
        flex-wrap wrap
        justify-content space-around
        padding  42rpx 12rpx 20rpx
        z-index: 3;
        .title
            position absolute
            left 13rpx;
            top: 5px;
            color #fff;
            font-size 13rpx
         $bg1 = url("../../../assets/images/leadingCockpit/frame_blue_left.png") left no-repeat
        .data-item
            box-sizing border-box
            padding 7rpx;
            padding-left 8rpx
            width 102rpx;
            margin 4rpx
            background $bg1,url("../../../assets/images/leadingCockpit/frame_blue_right.png") right no-repeat;
            background-size: auto 100%;
            .data-name
                color #fff;
                opacity: 0.5;
                font-size 10rpx
            .data-num
                font-size 20rpx
                font-family: Technology-Regular, Technology;
            .n1
                color #00B6F2
            .n2
                color #F97415
            .n3
                color #0096F8
            .n4
                color #F7B500
            .n5
                color #44D7B6
            .n6
                color #6DD400
    .legend-data
        position fixed
        left -10rpx;
        bottom 0
        width: 140rpx;
        height: 70rpx;
        background url("../../../assets/images/leadingCockpit/bg_home_3.png") no-repeat center
        background-size 100% 100%;
        z-index: 2;
        .title
            font-size 10rpx;
            color #fff;
            text-align center
            padding-right 12rpx;
            margin-top -1rpx;
        p
            margin 6rpx 0;
            padding-left 20rpx;
            display flex
            align-items center
            img
                width 10rpx;
            span
                margin-left 8rpx;
                font-size 10rpx;
                color #fff;
    .map-contain
        #mapChart
            height 100vh
            background url('../../../assets/images/leadingCockpit/bg.png') #0E1C31
</style>
